import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Phone, Calendar, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const foodImages = [
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/5984a11d-cf61-427e-83ae-1d37821589a2.jpeg", // IMG_4869.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/90ca7e06-f38b-41ab-bf23-fa341078958e.jpg",  // 6X6A0791-3.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/4d11d0b1-5134-4cbf-beea-5b4e23060e89.jpeg", // IMG_3973.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/1e345789-e081-4275-a052-e6174ae3bcfa.jpg",  // 6X6A2112.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/e7250693-36ff-4b98-a695-08a316a8d256.jpg",  // Billede15.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/66231572-a1dc-4ceb-88ed-30b18d545642.jpg",  // Billede17.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/2341ba95-bbc6-4ee9-9580-ffe63f081ccb.jpg",  // stegt torsk med skilt sauce.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/b505504c-bc0e-4517-ae3e-bff01f3dfbfe.jpeg", // IMG_3673.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/191fbe36-2cde-41e4-bd58-3d9773016ef2.jpg",  // banner  1.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/0b1a97b8-ccd9-47ed-be62-ff8258173974.jpeg", // IMG_4115.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/20d90ee2-a3a9-4431-90da-7e628dc34d6f.jpeg", // IMG_4953.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/000274af-e1b4-48c1-9654-d607082f64d7.jpg",  // Billede18.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/5e698c3f-92e9-4f91-b792-1f32e7449407.jpeg", // IMG_3052.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/bfe8c2fe-fe37-4f91-9761-620c5ad22b72.jpeg"  // IMG_8917.jpeg
];

// Helper to get Cloudflare resized image URL
const getResizedUrl = (url, width = 600) => {
  if (!url.startsWith("https://assets.auxodev.dk/")) return url;
  return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=80,format=auto/`);
};

export default function TakeawayCatering() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="bg-white min-h-screen pt-20 font-sans">
      
      {/* Hero Block */}
      <section 
        className="relative min-h-[400px] md:min-h-[50vh] flex items-center justify-center bg-cover bg-center py-20"
        style={{ backgroundImage: `url('https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/cae1873b-13bd-4910-b027-d3497f0bf544.jpeg')` }}
      >
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
             <h1 className="text-4xl md:text-6xl text-white font-serif tracking-wide mb-6">Take away & Catering</h1>
             <p className="text-white/90 text-lg md:text-xl leading-relaxed font-light">
               Nyd Spisehusets velsmagende retter derhjemme eller til jeres næste store begivenhed. Vi tilbyder både daglig take away og professionel catering til private og virksomheder.
             </p>
          </motion.div>
        </div>
      </section>

      {/* Take Away Section */}
      <section className="py-16 md:py-24 bg-white text-gray-800">
         <div className="container mx-auto px-6 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              
              <div className="lg:col-span-7 space-y-6 text-left">
                <span className="text-primary tracking-widest text-xs uppercase font-semibold italic">Hurtigt & Lækkert</span>
                <h2 className="text-3xl md:text-4xl font-serif text-gray-900">Take away i Værløse</h2>
                <p className="text-gray-700 leading-relaxed text-lg">
                  Du kan dagligt købe vores lækre menukort som takeaway ved at ringe til os på{" "}
                  <a href="tel:42952240" className="text-primary font-semibold hover:underline">
                    42 95 22 40
                  </a>
                  . Retterne tilberedes af friske råvarer med fokus på det gode håndværk, præcis som hvis du spiste i vores restaurant.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Uanset om du ønsker en hyggelig hverdagsmiddag eller vil forkæle dine gæster derhjemme med restaurantoplevelsen, står vores kokke klar til at pakke maden, så den holder sig varm og indbydende helt frem til dit middagsbord.
                </p>
                <div className="pt-4 flex flex-wrap gap-4">
                  <Link 
                    to="/spisehuset" 
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white hover:bg-primary/90 transition-colors uppercase tracking-wider text-xs font-semibold"
                  >
                    Se menukortet <ArrowRight size={16} />
                  </Link>
                  <a 
                    href="tel:42952240" 
                    className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors uppercase tracking-wider text-xs font-semibold"
                  >
                    <Phone size={16} /> Ring og bestil
                  </a>
                </div>
              </div>

              <div className="lg:col-span-5">
                <div className="relative">
                  <div className="absolute -inset-2 bg-primary/10 rounded-lg -rotate-2" />
                  <img 
                    src={getResizedUrl("https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/1e345789-e081-4275-a052-e6174ae3bcfa.jpg", 800)} 
                    alt="Lækker mad fra Spisehuset" 
                    className="relative rounded shadow-md w-full h-[350px] object-cover"
                  />
                </div>
              </div>

            </div>
         </div>
      </section>

      {/* Catering Section */}
      <section className="py-16 md:py-24 bg-bg-light border-y border-gray-100 text-gray-800">
         <div className="container mx-auto px-6 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-16">
              
              <div className="lg:col-span-5 order-2 lg:order-1">
                <div className="relative">
                  <div className="absolute -inset-2 bg-primary/10 rounded-lg rotate-2" />
                  <img 
                    src={getResizedUrl("https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/5984a11d-cf61-427e-83ae-1d37821589a2.jpeg", 800)} 
                    alt="Catering anretning" 
                    className="relative rounded shadow-md w-full h-[350px] object-cover"
                  />
                </div>
              </div>

              <div className="lg:col-span-7 space-y-6 text-left order-1 lg:order-2">
                <span className="text-primary tracking-widest text-xs uppercase font-semibold italic">Mad ud af huset</span>
                <h2 className="text-3xl md:text-4xl font-serif text-gray-900">Catering til private og virksomheder</h2>
                <p className="text-gray-700 leading-relaxed text-lg">
                  Vi tilbyder catering til private og virksomheder. Uanset om det drejer sig om en intim fødselsdag, konfirmation, bryllup, reception eller en stor firmafest, tilbyder vi mad ud af huset i særklasse.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Vores menuer tager altid udgangspunkt i sæsonens bedste og mest friske råvarer. Vi tilpasser gerne menuen efter jeres specifikke ønsker, allergier og præferencer, så alle jeres gæster får en uforglemmelig gastronomisk oplevelse.
                </p>
                <div className="pt-4">
                  <Link 
                    to="/kontakt" 
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white hover:bg-primary/90 transition-colors uppercase tracking-wider text-xs font-semibold"
                  >
                    <Calendar size={16} /> Indhent tilbud
                  </Link>
                </div>
              </div>

            </div>

            {/* Catering Menu Card */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white p-8 md:p-16 shadow-sm border border-gray-100 max-w-6xl mx-auto mt-20"
            >
              <div className="text-center mb-16">
                <h4 className="text-primary text-sm tracking-[0.2em] uppercase mb-4 font-medium">Catering Menu</h4>
                <h2 className="text-3xl md:text-4xl font-serif">Mad ud af huset menu</h2>
                <div className="w-24 h-px bg-primary/30 mx-auto mt-6"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-left">
                {/* Forretter */}
                <div>
                  <h3 className="text-xl font-serif mb-6 border-b border-primary/20 pb-2">Sharing forretter</h3>
                  <ul className="space-y-4 text-gray-700 font-light leading-relaxed">
                    <li>Citron rimmet laks serveret med gomamayo og friteret nudler og karse</li>
                    <li>Vafler med trøffelmayo og serano</li>
                    <li>Friteret kartoffelkroketter med aioli</li>
                    <li>Kuvertbrød og piskede smør</li>
                  </ul>
                </div>

                {/* Hovedretter */}
                <div>
                  <h3 className="text-xl font-serif mb-6 border-b border-primary/20 pb-2">Sharing hovedretter</h3>
                  <ul className="space-y-4 text-gray-700 font-light leading-relaxed">
                    <li>Kalvecuvette med hvidløg og timian</li>
                    <li>Ristede små kartofler vendt i urter og smør</li>
                    <li>Glaserede gulerødder med krydret kerner</li>
                    <li>Grønne asparges med ærtecreme og brøndkarse</li>
                    <li>Spisehusets rødvinssauce på demi glace</li>
                    <li>Rødesalater med blodappelsin vinaigrette og syltede rødløg</li>
                  </ul>
                </div>

                {/* Dessert & Info */}
                <div>
                  <h3 className="text-xl font-serif mb-6 border-b border-primary/20 pb-2">Dessert & Info</h3>
                  <div className="space-y-6">
                    <div>
                      <h4 className="text-sm uppercase tracking-wider text-primary mb-2 font-medium">Tallerken anrettet dessert</h4>
                      <p className="text-gray-700 font-light leading-relaxed">
                        Fransk citron tærte med blød og sprød marengs samt marineret bær.
                      </p>
                    </div>
                    
                    <div className="pt-6 border-t border-gray-100">
                      <p className="text-2xl font-serif text-primary mb-4">Menupris: 445,-</p>
                      <div className="space-y-2 text-sm text-gray-600 italic">
                        <p>Serveres på engangsemballage klar til servering.</p>
                        <p>Afhentes i spisehuset på Christianshøjvej 22, 3500 Værløse</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-gray-100 text-center">
                <p className="text-gray-700 italic">
                  Spisehuset kan ved henvendelse skabe en skræddersyet menu, som passer perfekt til jeres arrangement.
                </p>
              </div>
            </motion.div>
         </div>
      </section>

      {/* Gallery Block */}
      <section className="py-16 md:py-24 bg-white">
         <div className="container mx-auto px-6 max-w-7xl">
            <h2 className="text-3xl font-serif text-center mb-4">Glimt af vores mad</h2>
            <p className="text-gray-500 text-center mb-12 max-w-xl mx-auto font-light">
              Gå på opdagelse i vores udvalg af veltilberedte retter og anretninger, der viser vores passion for godt håndværk.
            </p>
            
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {foodImages.map((img, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05 }}
                  viewport={{ once: true }}
                  className="relative group overflow-hidden cursor-zoom-in h-[200px] md:h-[280px] rounded shadow-sm"
                  onClick={() => setSelectedImage(img)}
                >
                  <img 
                    src={getResizedUrl(img, 500)} 
                    alt={`Mad anretning ${index + 1}`} 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center" />
                </motion.div>
              ))}
            </div>
         </div>
      </section>

      {/* Lightbox Pop-up */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 md:p-10"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-6 right-6 text-white hover:text-primary transition-colors z-50"
              onClick={() => setSelectedImage(null)}
            >
              <X size={32} />
            </button>
            <motion.img 
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              src={selectedImage} 
              alt="Full size view" 
              className="max-w-full max-h-full object-contain shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}
